import React from "react";
import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    Button,
    makeStyles,
    tokens,
} from "@fluentui/react-components";

const useStyles = makeStyles({
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        padding: "20px 0",
    },
    streakNumber: {
        fontSize: "72px",
        fontWeight: "bold",
        color: tokens.colorBrandForeground1,
        lineHeight: "1",
    },
    streakLabel: {
        fontSize: "24px",
        color: tokens.colorNeutralForeground2,
    },
    message: {
        fontSize: "16px",
        color: tokens.colorNeutralForeground3,
        textAlign: "center",
        maxWidth: "300px",
    },
    footer: {
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
    },
});

interface StreakDialogProps {
    open: boolean;
    onClose: () => void;
    streak: number;
}

export function StreakDialog({ open, onClose, streak }: StreakDialogProps) {
    const styles = useStyles();

    const getMessage = () => {
        if (streak === 1) {
            return "Great start! Complete all challenges tomorrow to keep your streak going.";
        } else if (streak < 7) {
            return "Keep it up! You're building a great habit.";
        } else if (streak < 30) {
            return "Impressive! You're on fire! 🔥";
        } else {
            return "Legendary! You're a Numbers master! 🏆";
        }
    };

    return (
        <Dialog open={open} onOpenChange={(_, data) => !data.open && onClose()}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>All Challenges Complete! 🎉</DialogTitle>
                    <DialogContent className={styles.content}>
                        <div>
                            <div className={styles.streakNumber}>
                                {streak}
                                <div className={styles.streakLabel}>
                                    {streak === 1 ? "day" : "days"}
                                </div>
                            </div>
                        </div>
                        <div className={styles.message}>{getMessage()}</div>
                        <div className={styles.footer}>
                            <Button appearance="primary" onClick={onClose}>
                                Awesome!
                            </Button>
                        </div>
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}
